import React, { useState, useEffect } from 'react';
import VainillaDialog from '../../sharecomponents/vanilladialog';
import v from '../../../utils/Verifiers.jsx';
import AutoCompleteInput from '../../sharecomponents/AutocompleteImput.jsx';
import './OrdenesTrabajoInferidas.css';
import ImpresoraDeOrdenesTrabajoasignadas from './ordenesTrabajoOperativosComponents/ImpresoraDeOrdenesTrabajoasignadas.jsx';

const OrdenesTrabajoInferidas = () => {
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });

    //Datos iniciales que se obtienen una sola vez en la via del widget
    const [empleados, setempleados] = useState([]);
    const [empleadosNames, setempleadosNames] = useState([]);
    const [empleadosHash, setempleadosHash] = useState({});

    //Datos que se obtienen cada que se cambia de semana o día
    const [labores, setlabores] = useState([]);
    const [ordenes, setordenes] = useState([]);
    const [inferencias, setinferencias] = useState({});
    const [diasNoTimbrados, setdiasNoTimbrados] = useState([]);

    //datos de seleccion de labores
    const [laboresSeleccionadas, setlaboresSeleccionadas] = useState({});
    const [selecciones, setselecciones] = useState({ area: '0', labor: '', usuario: "", asignado: 0, fecha_ajustada: "" });
    const [fechas, setfechas] = useState({ semana: "", dia: "", semanas: [], dias: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'], semana_seleccion: '', dia_seleccion: '' });

    const [abrirImpresiones, setabrirImpresiones] = useState(false);

    useEffect(() => {
        getRendimientos().then(resp => {
            if (!resp) return;
            getActividadesDia(resp.dia, resp.semana);
        });
    }, []);

    const getRendimientos = async () => {
        const resp = await v.getDataAPI('nomina/oto/inferidos/rendimientos', {}, setloader, setdialog);
        if (!resp.estatus) return null;
        setfechas({
            ...fechas,
            semanas: resp.data.semanas,
            semana: resp.data.semana,
            semana_seleccion: resp.data.semana,
            dia: resp.data.dia,
            dia_seleccion: resp.data.dia
        })

        definirEmpleados(resp.data.empleados);
        return { dia: resp.data.dia, semana: resp.data.semana };
    }

    const definirEmpleados = (emps) => {
        setempleados(emps);
        setempleadosNames(emps.map(e => e.nombre));

        const hash = {};
        emps.forEach(e => { hash[e.nombre] = e; });
        setempleadosHash(hash);
        setselecciones({ ...selecciones, usuario: "" });
    }

    const getActividadesDia = async (dia = fechas.dia_seleccion, semana = fechas.semana_seleccion, fecha_ajustada) => {
        const resp = await v.getDataAPI('nomina/oto/inferidos/actividades', { semana, dia }, setloader, false);
        if (!resp?.estatus) return;
        setlabores([...resp.data.labores]);
        setinferencias({ ...resp.data.inferencias });
        setordenes([...resp.data.ordenes]);
        setdiasNoTimbrados({ ...resp.data.edicion_disponible });
        setlaboresSeleccionadas({});
        definirEmpleados(resp.data.empleados);
    }

    const getOrdenesServidor = async (dia = fechas.dia_seleccion, semana = fechas.semana_seleccion, fecha_ajustada = '') => {
        const resp = await v.getDataAPI('nomina/oto/get', { dia, semana, fecha_ajustada }, false, false);
        if (!resp?.estatus) return;
        setordenes([...resp.data.ordenes]);
    }

    const deleteOrdenBackend = async (id, i, j) => {
        if (!id) { eliminarOrdenLocal(i, j); return; }
        const resp = await v.getDataAPI(`nomina/oto/delete`, { id, force: fechaAjustada() ? true : false }, setloader, setdialog);
        if (!resp?.estatus) return;
        eliminarOrdenLocal(i, j);
    }

    const eliminarOrdenLocal = (i, j) => {
        let newOrds = [...ordenes];
        ordenes[i].labores.splice(j, 1);
        if (ordenes[i].labores.length === 0) newOrds.splice(i, 1);
        setordenes(newOrds);
    }

    const agregarALista = async () => {
        if (!puedeAgregar()) return;
        const labss = Object.values(laboresSeleccionadas);
        const asignado_a = empleadosHash[selecciones.usuario].id;
        const dia = fechas.dia_seleccion;
        const semana = fechas.semana_seleccion;
        console.log('agregarALista', labss);
        const ordss = labss.map(lab => ({
            nomina_rendimiento_id: lab.labor.nomina_rendimiento_id,
            cantidad: lab.cantidad
        }));

        const resp = await v.getDataAPI('nomina/oto/add/multiple', {
            asignado_a: asignado_a,
            semana: semana,
            dia: dia,
            ordenes: ordss
        }, false, setdialog);

        if (!resp?.estatus) {
            getOrdenesServidor();
            return;
        }
        setlabores([...resp.data.labores]);
        setinferencias({ ...resp.data.inferencias });
        setordenes([...resp.data.ordenes]);
        setdiasNoTimbrados({ ...resp.data.edicion_disponible });
        setlaboresSeleccionadas({});
        // setordenes([...resp.data.ordenes]);
    }

    const ajustar_cumplimiento = (orden, labor, cantidad) => {
        cantidad = v.numberFormat(cantidad, 0);
        if (cantidad < 0) cantidad = 0;
        const lb = ordenes[orden].labores[labor];
        const usuario_id = ordenes[orden].asignado_a;
        const asignado = lb.asignado;

        guardarServidor(lb.labor, usuario_id, asignado, cantidad, lb.otp_id ?? null);

        let ord = [...ordenes];
        ord[orden].labores[labor].unidades_realizadas = cantidad;
        setordenes(ord);
    }

    const guardarServidor = async (lab, asignado_a, asignado = null, unidades_realizadas = null, id = null) => {
        const payload = Array.isArray(lab) ? lab.map(lb => {
            return {
                nomina_rendimiento_id: lb.labor.nomina_rendimiento_id,
                unidades_asignadas: lb.asignado,
                asignado_a: asignado_a,
                unidades_realizadas: lb.asignado,
                id: lb.labor.id
            }
        }) : [{
            nomina_rendimiento_id: lab.nomina_rendimiento_id,
            unidades_asignadas: asignado,
            asignado_a: asignado_a,
            unidades_realizadas: unidades_realizadas,
            id: id
        }];

        const resp = await v.getDataAPI('nomina/oto/add',
            {
                ordenes: payload,
                dia: fechas.dia_seleccion,
                semana: fechas.semana_seleccion,
                asignado_a
            },
            false,
            setdialog,
            'POST'
        );
        if (!resp?.estatus) {
            getOrdenesServidor();
            return;
        }
        setordenes([...resp.data.ordenes]);
    }

    const barraAvance = (i, j) => {
        const lb = ordenes[i].labores[j];
        const asignado = lb.asignado;
        const relalizado = lb.unidades_realizadas ?? 0;
        const avance = Math.min(100, Math.max(2, (relalizado / asignado) * 100));

        return (<div className="w round-right-xl m-0 p-0" style={{ '--w': `${avance}%`, height: "2px", backgroundColor: colorPorcentaje(avance) }}></div>)
    }

    const colorPorcentaje = (porcentaje) => {
        if (porcentaje < 20) return '#eb1f00ff';
        if (porcentaje < 45) return '#f09800ff';
        if (porcentaje < 90) return '#ded704ff';
        if (porcentaje < 100) return '#00ae06ff';
        return 'rgba(1, 102, 160, 1)';
    }

    const fechaAjustada = (semana = null, dia = null) => {
        semana = semana ?? fechas.semana_seleccion;
        dia = dia ?? fechas.dia_seleccion;
        const ajustable = diasNoTimbrados[semana]?.[dia] ?? false;
        return !ajustable ? false : `${semana}|${dia}`;
    };

    const extraerInferenciasPorFlor = () => {
        const inf = inferencias[selecciones.labor];
        const bloques = {};
        const labores = Object.values(inf.labores);
        labores.forEach(lab => {
            const bloque = (lab?.labor?.bloque ?? '').split(' - ')?.[0] ?? '';
            const flor = bloque.split(' ')[0];
            if (flor === '') flor = "SIN FLOR";
            const asignado = lab.asignado ?? 0;
            const realizado = lab.realizado ?? 0;
            const faltante = Math.max(0, (lab?.labor?.charolas ?? 0) - asignado);
            const tiempo = (lab?.labor?.ms_by_unidad ?? 0) * faltante;
            if (!bloques[flor]) bloques[flor] = { flor: flor, faltante: 0, tiempo: 0, um: lab.labor.um, labores: [] };
            bloques[flor].faltante += faltante;
            bloques[flor].tiempo += tiempo;
            bloques[flor].labores.push(lab);
        });
        return Object.values(bloques);
    }

    const cantidadLaborSeleccionada = (lab) => {
        const labor = lab.labor;
        if (laboresSeleccionadas[labor.id]) return laboresSeleccionadas[labor.id].cantidad;
        return Math.max(0, ((lab.labor.charolas ?? 0) - (lab.asignado ?? 0)));
    }

    const enFechaActual = () => (fechas.semana_seleccion === fechas.semana && +fechas.dia_seleccion === +fechas.dia);

    const calcularNomina = (labores) => {
        const tiempo_primer_turno = 30600000;
        const tiempo_segundo_turno = 21600000;

        const turnos = { primero: { tiempo: 0, registros: [] }, segundo: { tiempo: 0, registros: [] }, bono: { total: 0, registros: [] } };
        const len = labores.length;
        for (let i = 0; i < len; i++) {
            const lab = labores[i];
            const labor = lab.labor;
            const ms_totales = labor.ms_by_unidad * (lab.unidades_realizadas ?? 0);

            //Si aún no se completa el primer turno se realiza lo siguiente
            if (turnos.primero.tiempo < tiempo_primer_turno) {
                if ((turnos.primero.tiempo + ms_totales) <= tiempo_primer_turno) {
                    turnos.primero.tiempo += ms_totales;
                    turnos.primero.registros.push(JSON.parse(JSON.stringify(lab)));
                    continue;
                }

                const resp = divirRegistro(tiempo_primer_turno, turnos.primero.tiempo, lab);
                const valor1 = resp.valor1;
                const valor2 = resp.valor2;

                turnos.primero.tiempo = tiempo_primer_turno;
                turnos.primero.registros.push(valor1);

                const tiempo_valor2 = labor.ms_by_unidad * valor2.unidades_realizadas;

                if (tiempo_segundo_turno < tiempo_valor2) {
                    //El excedente exece el segundo turno
                    const resp2 = divirRegistro(tiempo_segundo_turno, tiempo_valor2, lab);
                    const vv1 = resp2.valor1;
                    const vv2 = resp2.valor2;

                    turnos.segundo.tiempo = tiempo_segundo_turno;
                    turnos.segundo.registros.push(vv1);

                    turnos.bono.total += vv2.unidades_realizadas * lab.labor.pago_unidad ?? 0;
                    turnos.bono.registros.push(vv2);
                    continue;
                }

                turnos.segundo.tiempo += tiempo_valor2;
                turnos.segundo.registros.push(valor2);
                continue;
            }

            //Si ya se completó el primer turno y aún no se completa el segundo turno
            if (turnos.segundo.tiempo < tiempo_segundo_turno) {
                if ((turnos.segundo.tiempo + ms_totales) <= tiempo_segundo_turno) {
                    turnos.segundo.tiempo += ms_totales;
                    turnos.segundo.registros.push(JSON.parse(JSON.stringify(lab)));
                    continue;
                }
                const resp = divirRegistro(tiempo_segundo_turno, turnos.segundo.tiempo, lab);
                const valor1 = resp.valor1;
                const valor2 = resp.valor2;

                turnos.segundo.tiempo = tiempo_segundo_turno;
                turnos.segundo.registros.push(valor1);

                turnos.bono.total += valor2.unidades_realizadas * lab.labor.pago_unidad ?? 0;
                turnos.bono.registros.push(valor2);
                continue;
            }

            //Si ya se completaron ambos turnos, todo va a bono
            turnos.bono.total += (lab.unidades_realizadas ?? 0) * lab.labor.pago_unidad ?? 0;
            turnos.bono.registros.push(JSON.parse(JSON.stringify(lab)));
        }

        turnos.primero.realizado = +(turnos.primero.tiempo / tiempo_primer_turno).toFixed(2) * 100;
        turnos.segundo.realizado = +(turnos.segundo.tiempo / tiempo_segundo_turno).toFixed(2) * 100;

        return (<div className={`row d-flex m-0 p-0 justify-content-start w-100`}>
            {barraAvanceTurnos(turnos.primero.realizado, '1º Turno', turnos.primero.realizado.toFixed(2) + '%')}
            {barraAvanceTurnos(turnos.segundo.realizado, '2º Turno', turnos.segundo.realizado.toFixed(2) + '%')}
            {barraAvanceTurnos(turnos.bono.total > 0 ? 100 : 0, 'Bono:', '$' + +v.numberFormat(turnos.bono.total, 2).toFixed(2), '')}
        </div>)
    }

    const barraAvanceTurnos = (avance, nombre, helpText) => (
        <div className={`bw-100 p-0 ms-2 me-2`}>
            <div className="w text-s" style={{ '--w': '100%' }}>{nombre}<span className='ms-1 text-bold'>{helpText}</span></div>
            <div className={`bw-100 round-xxl border text-start p-0 bg-black5`} style={{ overflow: "hidden" }}>
                <div className={`m-0 p-0`} style={{ minHeight: "4px", width: `${avance}%`, backgroundColor: colorPorcentaje(avance), transition: "width 1s ease-in-out", overflow: 'visible' }}></div>
            </div>
        </div>
    )

    const divirRegistro = (tiempoMaximo, tiempo_actual, lab) => {
        const valor1 = { asignado: 0, unidades_realizadas: 0, labor: { ...lab.labor } };
        const valor2 = { asignado: 0, unidades_realizadas: 0, labor: { ...lab.labor } };

        const ms_by_unidad = lab.labor.ms_by_unidad;
        const tiempo_valor1 = tiempoMaximo - tiempo_actual;
        const unidades_valor1 = Math.floor(tiempo_valor1 / ms_by_unidad);
        const unidades_valor2 = (lab.unidades_realizadas ?? 0) - unidades_valor1;
        const tiempo_valor2 = ms_by_unidad * unidades_valor2;

        valor1.unidades_realizadas = unidades_valor1;
        valor2.unidades_realizadas = unidades_valor2;

        return { valor1: valor1, valor2: valor2 };
    }

    const calculoSeleccionado = () => {
        const values = Object.values(laboresSeleccionadas);
        let total_tiempo = 0;
        let total_labores = values.length;
        let total_um = 0;
        let um = "unidades"
        values.forEach(e => {
            total_tiempo += (e.cantidad * e.labor.ms_by_unidad);
            total_um += e.cantidad;
            um = e.labor.um;
        });
        return (<div className='w-100 h5 text-300'>
            <span className='text-bold'>{total_labores}</span> Labores asignadas,
            <span className='text-bold ms-4'>{total_um}</span> {um},
            <span className='text-bold ms-4'>{+(total_tiempo / 3600000).toFixed(2)}</span> Horas totales
        </div>)
    }

    const tiempo_asignar = () => {
        const values = Object.values(laboresSeleccionadas);
        let total_tiempo = 0;
        values.forEach(e => {
            total_tiempo += (e.cantidad * e.labor.ms_by_unidad);
        });
        return ` ${+(total_tiempo / 3600000).toFixed(2)} Horas`;
    }

    const puedeAgregar = () => Object.keys(laboresSeleccionadas).length > 0 && selecciones.usuario !== '';

    const selecconarTodasLabores = () => {
        const ls = { ...laboresSeleccionadas };
        const listLabores = Object.values(inferencias?.[selecciones.labor]?.labores ?? {});

        listLabores.forEach(lab => {
            const labor = lab.labor;
            const asignado = v.numberFormat(lab.asignado, 0);
            const charolas = v.numberFormat(labor.charolas, 0);
            const diff = charolas - asignado;
            if (diff > 0) {
                ls[labor.id] = { cantidad: diff, labor: labor };
            }
        });
        setlaboresSeleccionadas({ ...ls });
    }

    const tiempoPrimerTurno = (contratista) => {
        //if (contratista) return 28800000; // 8 horas
        if (+fechas.dia_seleccion >= 6) return 18000000; // 5 horas
        return 30600000; // 8.5 horas
    }

    const dibujarBarrasAvanceNomina = (labores, contratista) => {
        const tiempo_primer_turno = tiempoPrimerTurno(contratista);
        const tiempo_segundo_turno = 21600000; // 04:00 PM a 10:00 PM (6 horas)
        const nomina = calcularNominas(labores, contratista);

        nomina.primero.realizado = +(nomina.primero.tiempo / tiempo_primer_turno).toFixed(3) * 100;
        nomina.segundo.realizado = +(nomina.segundo.tiempo / tiempo_segundo_turno).toFixed(3) * 100;

        return (<div className={`row d-flex m-0 p-0 justify-content-start w-100`}>
            {barraAvanceTurnos(nomina.primero.realizado, '1º Turno', +nomina.primero.realizado.toFixed(3) + '%')}
            {barraAvanceTurnos(nomina.segundo.realizado, '2º Turno', +nomina.segundo.realizado.toFixed(3) + '%')}
            {barraAvanceTurnos(nomina.bono.total > 0 ? 100 : 0, 'Bono:', '$' + +v.numberFormat(nomina.bono.total, 2).toFixed(2), '')}
        </div>)
    }

    const calcularNominas = (labores, contratista) => {
        let labores_restantes = [];
        const turnos = { primero: { tiempo: 0, registros: [] }, segundo: { tiempo: 0, registros: [[]] }, bono: { total: 0, registros: [] } };
        const tiempo_primer_turno = tiempoPrimerTurno(contratista);
        const resp_t1 = extraerTurno(JSON.parse(JSON.stringify(labores)), tiempo_primer_turno); // 8.5 o 5 horas dependiendo el dia
        if (resp_t1.realizado >= 0.99) {
            turnos.primero.tiempo = tiempo_primer_turno;
            turnos.primero.registros = resp_t1.labores_incluidas;
            labores_restantes = resp_t1.labores_restantes;
        } else {
            turnos.primero.tiempo = resp_t1.tiempo_realizado;
            turnos.primero.registros = resp_t1.labores_incluidas;
            return turnos;
        }

        if (labores_restantes.length == 0) return turnos;

        let valorRealizado = 0;
        do {
            let turno_02 = extraerTurno(JSON.parse(JSON.stringify(labores_restantes)), 21600000); // 6 horas
            valorRealizado = turno_02.realizado;
            if (valorRealizado >= 0.99) {
                turnos.segundo.tiempo += 21600000;
                turnos.segundo.registros = [...turnos.segundo.registros, ...turno_02.labores_incluidas];
                labores_restantes = turno_02.labores_restantes;
            }
        } while (valorRealizado >= 0.99);

        //Lo que quede va a bono
        if (labores_restantes.length > 0) {
            labores_restantes.forEach(labo => {
                turnos.bono.total += (labo.unidades_realizadas ?? 0) * (labo.labor.pago_unidad ?? 0);
                turnos.bono.registros.push(labo);
            });
        }
        return turnos;
    }

    //Aparta los registros que correspondan com maximo al tiempo indicado
    const extraerTurno = (labores, tiempo) => {
        let tiempo_realizado = 0;
        let labores_incluidas = [];
        let labores_restantes = [];
        let finalizado = false;
        const len = labores.length;

        for (let i = 0; i < len; i++) {
            //Si ya se finalizó el tiempo necesario a cumpllir solo agregamos la labores a las labores restantes
            if (finalizado) {
                labores_restantes.push(labores[i]);
                continue;
            }

            const lab = labores[i];
            const labor = lab.labor;
            const labor_ms_relizados = labor.ms_by_unidad * (lab.unidades_realizadas ?? 0);
            const suma_tiempo_total = labor_ms_relizados + tiempo_realizado;

            //Si el tiempo total de la labor + lo contabilizado es inferior al tiempo objetivo solo suamos la labor completa
            if (suma_tiempo_total <= tiempo) {
                tiempo_realizado += labor_ms_relizados;
                labores_incluidas.push(lab);
                continue;
            }

            //Si el total de la labor + lo contabilizado es igual al tiempo objetivo sumamos y terminamos el ciclo
            if (suma_tiempo_total === tiempo) {
                tiempo_realizado += labor_ms_relizados;
                labores_incluidas.push(lab);
                finalizado = true;
                continue;
            }

            //Si el total realizado excede el tiempo que deberiamos completar dividimos la labor para obtener solo lo necesario
            if (suma_tiempo_total > tiempo) {
                const resp = divirLaborRealizada(tiempo, tiempo_realizado, lab);

                tiempo_realizado += labor.ms_by_unidad * resp.incluida.unidades_realizadas;
                labores_incluidas.push(resp.incluida);
                labores_restantes.push(resp.excedente);

                //Finalizamos el conteo de labores
                finalizado = true;
                continue;
            }
        }
        const total_tiempo_objetivo_realizado = +(tiempo_realizado / tiempo).toFixed(2);
        return { labores_incluidas, labores_restantes, realizado: total_tiempo_objetivo_realizado, tiempo_realizado: tiempo_realizado };
    }

    /**
     * Solo se debe usar en labores que exceden el tiempo objetivo suamndo el tiempo de la labor + el tiempo actual
     * Divide la labor en dos, una que se contiene el cumplimiento necesario para llegar al tiempo objetivo y otra con el excedente 
     * @param {int} tiempo_objetivo tiempo maximo que se debe cubrir 
     * @param {int} tiempo_actual tiempo ya contabilizado
     * @param {object} laborImplicada objeto con la labor y su cumplimiento en formato estandar
     * @returns {object} objeto con las dos labores divididas en incluida y excedente
     */
    const divirLaborRealizada = (tiempo_objetivo, tiempo_actual, laborImplicada) => {
        const labor_incluida = { asignado: 0, unidades_realizadas: 0, labor: { ...laborImplicada.labor } };
        const labor_excedente = { asignado: 0, unidades_realizadas: 0, labor: { ...laborImplicada.labor } };

        const ms_by_unidad = laborImplicada.labor.ms_by_unidad;
        const tiempo_incluido = tiempo_objetivo - tiempo_actual;

        const unidades_incluidas = tiempo_incluido / ms_by_unidad;
        const unidades_excedentes = (laborImplicada.unidades_realizadas ?? 0) - unidades_incluidas;

        labor_incluida.unidades_realizadas = unidades_incluidas;
        labor_excedente.unidades_realizadas = unidades_excedentes;

        return { incluida: labor_incluida, excedente: labor_excedente };
    }

    const millisegundosAHoras = (ms) => {
        return +(ms / 3600000).toFixed(3);
    }

    const laborRestringida = (lab) => {
        const areaNombre = (lab?.labor?.area_nombre ?? "").toUpperCase();
        return !['VIVERO', ""].includes(areaNombre);
    }

    return (
        <>
            <div className='w-100 m-0 p-0' style={{ height: "calc(100vh - 100px)", overflowY: 'auto' }}>
                <div className='row justify-content-around w-100 m-0 p-0'>
                    <div className="w text-center w-300 h3 m-0 mb-1 p-0 bg-black5 contenedor round-top-xl mt-1" style={{ '--w': '100%', height: "58px" }}>
                        ASIGNACIÓN DE ORDENES INFERIDAS DE INVENTARIOS
                        <i className={`${ordenes.length > 0 ? 'pointer' : ''} text-red3 ms-3 fa fa-file-pdf`} style={{ transition: "all 1.2s ease-in-out", opacity: ordenes.length > 0 ? 1 : 0 }} title='Abrir generador de impresiones' onClick={() => { if (ordenes.length > 0) setabrirImpresiones(true) }}></i>
                    </div>
                    <div className="bw blur-xl" style={{ '--bw': '1600px', position: "sticky", top: 0, zIndex: 2 }}>
                        <div className='row justify-content-around w-100 m-0 p-0'>
                            <div className="bw m-0 mb-2" style={{ '--bw': '100px' }}>
                                <label className='text-bold w-100 text-start text-s ps-2'>SEMANA</label>
                                <select className='form-control form-control-sm round-xs border border-2 shadow-sm'
                                    value={fechas.semana_seleccion}
                                    onChange={(e) => {
                                        const fajust = fechaAjustada(e.target.value, fechas.dia_seleccion);
                                        setfechas({ ...fechas, semana_seleccion: e.target.value, fecha_ajustada: fajust });
                                        setselecciones({ ...selecciones, fecha_ajustada: fajust, labor: '' });
                                        getActividadesDia(fechas.dia_seleccion, e.target.value);
                                    }}>
                                    {(fechas?.semanas ?? []).map((e, i) => <option key={'sem' + i} value={e}>{e}</option>)}
                                </select>
                            </div>

                            <div className="bw m-0 mb-2" style={{ '--bw': '150px' }}>
                                <label className='text-bold w-100 text-start text-s ps-2'>DÍA</label>
                                <select className='form-control form-control-sm round-xs border border-2 shadow-sm'
                                    value={fechas.dia_seleccion}
                                    onChange={(e) => {
                                        const fajust = fechaAjustada(fechas.semana_seleccion, e.target.value);

                                        setfechas({ ...fechas, dia_seleccion: e.target.value, fecha_ajustada: fajust });
                                        setselecciones({ ...selecciones, fecha_ajustada: fajust, labor: '' });
                                        getActividadesDia(e.target.value, fechas.semana_seleccion);
                                    }}>
                                    {(fechas?.dias ?? []).map((e, i) => <option key={'dia' + i} value={i + 1}>{e}</option>)}
                                </select>
                            </div>

                            <div className="bw m-0 mb-2 p-0 text-center" style={{ '--bw': '140px' }}>
                                <label className='text-bold w-100 text-center text-s ps-2'>Fecha editable</label>
                                <i className={`fa fa-calendar ${fechaAjustada() ? 'text-primary' : 'text-secondary'}`} />
                            </div>

                            <div className="bw m-0 mb-2" style={{ '--bw': '250px' }}>
                                <label className='text-bold w-100 text-start text-s ps-2'>LABOR</label>
                                <select className='form-control form-control-sm round-xs border border-2 shadow-sm'
                                    disabled={selecciones.area === '' || !enFechaActual() && !fechaAjustada()}
                                    value={selecciones.labor}
                                    onChange={(e) => {
                                        setselecciones({ ...selecciones, labor: e.target.value });
                                        setlaboresSeleccionadas({});
                                    }}>
                                    <option value='' >Ver asignaciones</option>
                                    {(labores ?? []).map((labor, i) => <option key={i + 'lbr'} value={labor}>{labor}</option>)}
                                </select>
                            </div>

                            <AutoCompleteInput
                                style="bw-300 relative m-0 mb-2"
                                label='SELECCIONE UN USUARIO'
                                inputClass={' round-xs form-control-sm border border-2 shadow-sm text-center contenedor ' + (!selecciones.usuario ? '' : 'border border-success border-2')}
                                text_class="text-bold ps-2 w-100 text-s text-start"
                                id="laborador-input"
                                disabled={empleados.length === 0 || selecciones.labor === '' || !enFechaActual() && !fechaAjustada()}
                                match={empleadosNames}
                                function={(selectUser) => {
                                    if (empleadosHash[selectUser]) setselecciones({ ...selecciones, usuario: empleadosHash[selectUser].nombre });
                                    else setselecciones({ ...selecciones, usuario: '' });
                                }}
                            />


                            <div className="bw contenedor pt-2" style={{ '--bw': '150px' }}>
                                <button className={`btn btn-sm btn-${puedeAgregar() ? 'warning shadow border-dark text-bold' : 'light'}  border-2 border round-xs w-100`}
                                    disabled={!enFechaActual() && !fechaAjustada() || !puedeAgregar()}
                                    onClick={agregarALista}
                                    style={{ transition: "all 0.5s ease-in-out" }}>Asignar{tiempo_asignar()}</button>
                            </div>
                        </div>
                    </div>


                    <div className='w-100'></div>
                    {selecciones.labor !== "" && inferencias[selecciones.labor] && <div className="bw p-1" style={{ '--bw': '1500px', overflow: 'auto' }}>
                        <div className='row justify-content-start w-100 m-0 p-0'>
                            <div className='col-auto text-start text-300 h2 m-0 p-0' style={{ maxWidth: "100%" }}>{selecciones.labor}</div>
                            <div className='bw-200'>
                                <button className='btn btn-sm w-100 btn-light shadow text-bold border border-warning border-2 ' onClick={selecconarTodasLabores}>Seleccionar todas las labores</button>
                            </div>
                        </div>
                        <div className='bw-1200 border-bottom border-warning '></div>
                        <div className='col-lg-100 p-2 selecciones-estadistica' >
                            {calculoSeleccionado()}
                        </div>
                        {extraerInferenciasPorFlor().map((bloq) => (
                            <div className='col-lg-12 m-0 p-0 overflow mb-5' key={"florlab " + bloq.flor} style={{ width: "1200px", maxWidth: "100%" }}>
                                <div className="w text-300 m-0 p-0" style={{ '--w': '100%' }}>
                                    <table className='table table-sm border-none m-0 p-0'>
                                        <tbody>
                                            <tr className='border-none m-0 p-0'>
                                                <td scope='row' className='bg-transparent nowrap h3 align-middle border-none m-0 p-0'>{bloq.flor}</td>
                                                <td className='bg-transparent nowrap align-middle border-none m-0 p-0'>Faltante: <span className='text-bold ms-1 me-1'>{bloq.faltante}</span>{bloq.um}</td>
                                                <td className='bg-transparent nowrap border-none m-0 p-0'>
                                                    Tiempo total faltante:<span className='text-bold ms-1 me-1'>{+(bloq.tiempo / 3600000).toFixed(3)}</span>Horas
                                                </td>
                                                <td className='bg-transparent nowrap border-none m-0 p-0'>
                                                    {/*<button className='btn btn-light shadow p-0 m-0 bw-300'
                                                        onClick={() => {
                                                            const ls = { ...laboresSeleccionadas }
                                                            bloq.labores.forEach(lab => {
                                                                const labor = lab.labor;
                                                                const asignado = v.numberFormat(lab.asignado, 0);
                                                                const charolas = v.numberFormat(labor.charolas, 0);
                                                                const diff = charolas - asignado;

                                                                if (diff > 0) {
                                                                    ls[labor.id] = { cantidad: diff, labor: labor };
                                                                }
                                                            });
                                                            setlaboresSeleccionadas({ ...ls });
                                                        }}
                                                    >
                                                        Sel. todo de <span className='text-bold text-xs'>{bloq.flor}</span>
                                                    </button>*/}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <table className='table table-sm table-bordered m-0 pt-0 mt-1'>
                                    <thead>
                                        <tr >
                                            <th className='nowrap' scope='col'>Bloque</th>
                                            <th className='nowrap' scope='col'>Ch. Inventario</th>
                                            <th className='nowrap' scope='col'>Asig. | reali.</th>
                                            <th className='nowrap' scope='col'>Inv. - Asig.</th>
                                            <th className='nowrap' scope='col' style={{ width: "100px" }}>Asignar</th>
                                            <th className='nowrap' scope='col' style={{ width: "130px" }}>
                                                <div className='row justify-content-around align-items-center w-100 m-0 p-0'>
                                                    <button className='btn btn-light shadow p-0 m-0 border border-warning border-2 w-60 round-0 text-bold'
                                                        onClick={() => {
                                                            const ls = { ...laboresSeleccionadas }
                                                            bloq.labores.forEach(lab => {
                                                                const labor = lab.labor;
                                                                const asignado = v.numberFormat(lab.asignado, 0);
                                                                const charolas = v.numberFormat(labor.charolas, 0);
                                                                const diff = charolas - asignado;

                                                                if (diff > 0) {
                                                                    ls[labor.id] = { cantidad: diff, labor: labor };
                                                                }
                                                            });
                                                            setlaboresSeleccionadas({ ...ls });
                                                        }}
                                                    >
                                                        + todo
                                                    </button>
                                                    <button className='btn btn-light shadow p-0 m-0 border border-secondary border-2 w-35 round-0 text-bold text-xs'
                                                        onClick={() => {
                                                            const ls = { ...laboresSeleccionadas }
                                                            bloq.labores.forEach(lab => {
                                                                const labor = lab.labor;
                                                                if (ls[labor.id]) {
                                                                    delete ls[labor.id];
                                                                }
                                                            });
                                                            setlaboresSeleccionadas(ls);
                                                        }}
                                                    >
                                                        - todo
                                                    </button>
                                                </div>
                                            </th>
                                            <th className='nowrap' scope='col'>Sum. Hr</th>
                                            <th className='nowrap' scope='col'>Sum. ch</th>
                                            <th className='nowrap' scope='col'>Se. Total</th>
                                            <th className='nowrap' scope='col'>Se. Asig</th>
                                            <th className='nowrap' scope='col'>Se. Reali</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bloq.labores.map((lab, i) =>
                                            <tr key={i + 'labrow'} className={`${laboresSeleccionadas[lab.labor.id] ? 'bg-selected-hover' : 'bg-hover'}`}>
                                                <td scope='row' className='bg-transparent nowrap'>{lab.labor.bloque}</td>
                                                <td className='bg-transparent nowrap'>{lab.labor.charolas}</td>
                                                <td className='bg-transparent nowrap'>
                                                    <span className='text-m text-400 text-blue3 ms-3'>{lab.asignado}</span>
                                                    <span className='text-bold h5 ms-1 me-1'>|</span>
                                                    <span className='text-m text-400 me-3 text-green3'>{lab.realizado}</span>
                                                </td>
                                                <td className='bg-transparent nowrap'>{Math.max(0, lab.labor.charolas - lab.asignado)}</td>
                                                <td className='m-0 p-0 bg-transparent nowrap' style={{ width: "100px" }}>
                                                    <input type='number' className='form-control form-control-sm round-0'
                                                        value={cantidadLaborSeleccionada(lab)}
                                                        onChange={(e) => {
                                                            const labor = lab.labor;
                                                            const val = v.numberFormat(e.target.value, 0);
                                                            const lb = { ...laboresSeleccionadas };
                                                            if (!lb[labor.id]) {
                                                                lb[labor.id] = { cantidad: 0, labor: labor };
                                                            }
                                                            lb[labor.id].cantidad = val;
                                                            setlaboresSeleccionadas({ ...lb });
                                                        }}
                                                    />
                                                </td>
                                                <td className='bg-transparent nowrap' style={{ width: "130px" }}>
                                                    <button className={`btn p-0 w-100 btn-${laboresSeleccionadas[lab.labor.id] ? 'warning text-bold' : 'light shadow'} w-100 round-0`}
                                                        onClick={() => {
                                                            const ls = { ...laboresSeleccionadas }
                                                            const labor = lab.labor;
                                                            if (ls[labor.id]) delete ls[labor.id];
                                                            else ls[labor.id] = { cantidad: Math.max(0, v.numberFormat(labor.charolas, 0) - v.numberFormat(labor.asignado, 0)), labor: labor };
                                                            setlaboresSeleccionadas({ ...ls });
                                                        }}
                                                    >
                                                        {!laboresSeleccionadas[lab.labor.id] ? 'Seleccionar' : "Deseleccionar"}
                                                    </button>
                                                </td>
                                                <td className='bg-transparent nowrap text-end'>
                                                    {millisegundosAHoras(bloq.labores.reduce((acc, curr, index) => {
                                                        if (index > i) return acc;
                                                        return acc + curr.labor.charolas * curr.labor.ms_by_unidad;
                                                    }, 0))}<span className='text-s ms-1'>Hr</span>
                                                </td>
                                                <td className='bg-transparent nowrap text-end'>
                                                    {bloq.labores.reduce((acc, curr, index) => {
                                                        if (index > i) return acc;
                                                        return acc + curr.labor.charolas;
                                                    }, 0)
                                                    }<span className='text-s ms-1'>Ch</span>
                                                </td>
                                                <td className='bg-transparent nowrap text-end'>{lab.labor.total_semana}</td>
                                                <td className='bg-transparent nowrap text-end'>{lab.labor.total_asignado}</td>
                                                <td className='bg-transparent nowrap text-end'>{lab.labor.total_realizado}</td>
                                            </tr>)}
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </div>}

                    {selecciones.labor == "" && ordenes.length > 0 && <div className="bw p-1" style={{ '--bw': '1250px', overflow: 'auto' }}>
                        <table className='table table-sm'>
                            <thead>
                            </thead>
                            <tbody>
                                {
                                    ordenes.map((e, i) => (
                                        <React.Fragment key={i + 'ord'}>
                                            <tr className='bg-black2 text-white'>
                                                <th scope='row'
                                                    className='text-bold ps-2 border-bottom border-dark'
                                                    style={{ fontSize: "15px" }}
                                                >
                                                    <div className='row justify-content-between w-100 m-0 p-0'>
                                                        <div className='bw-600'>{e.nombre_empleado} {e.contratista && <span className='text-xxs text-red2 ms-2'>Contratista</span>}</div>
                                                        <div className='bw-200'>
                                                            <button className='btn btn-light btn-sm w-100 shadow p-0 m-0 border-warning border-2 round-0 text-bold'
                                                                onClick={() => {
                                                                    const ordenesFiltradas = e.labores
                                                                        .map(lb => (lb?.labor?.area_nombre ?? "").toUpperCase() === "VIVERO" ? lb : null)
                                                                        .filter(lb => lb !== null);
                                                                    if (ordenesFiltradas.length === 0) return;
                                                                    guardarServidor(ordenesFiltradas, e.asignado_a);
                                                                }}
                                                            >
                                                                Cumplir todo
                                                            </button>
                                                        </div>
                                                    </div>

                                                </th>
                                            </tr>
                                            <tr className='bg-black2 text-white border-none m-0 p-0'>
                                                <td className='border-none p-0 m-0'>
                                                    <div className="w m-0 pt-0 pe-2 pb-0 bg-white ps-5" style={{ '--w': '100%' }}>
                                                        <table className='table table-sm' style={{ fontSize: "13px" }}>
                                                            <thead>
                                                                <tr>
                                                                    <th scope='col' className='text-secondary'>LABOR</th>
                                                                    <th scope='col' className='text-secondary' style={{ width: "250px" }}>ASIGNADO</th>
                                                                    <th scope='col' className='text-center text-secondary' style={{ width: "120px" }}>REALIZADO</th>
                                                                    <th scope='col' className='text-end pe-3 text-secondary' style={{ width: "180px" }}>HORAS ASIGNADAS</th>
                                                                    <th scope='col' className='border-start text-center text-secondary' style={{ width: "150px" }}>ACCION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    e.labores.map((lab, j) => (
                                                                        <tr key={j + 'lab'}>
                                                                            <td className='nowrap align-middle'>{lab.labor.labor}{lab.otp_id === null ? (<span className='text-xs text-bold text-purple3 opacity-70 ms-1'>Ord. siembra</span>) : ''}</td>
                                                                            <td className='nowrap align-middle' style={{ width: "250px" }}>{lab.asignado} - {lab.labor.um}</td>
                                                                            <td className={'text-end p-0 m-0 nowrap align-middle'} style={{ width: "120px" }}>
                                                                                {lab.otp_id && fechaAjustada() && !laborRestringida(lab) && <div className='row justify-content-between w-100 m-0 p-0'>
                                                                                    <input type='number'
                                                                                        className='form-control form-control-sm m-0 pt-0 pb-0 w-55'
                                                                                        value={lab.unidades_realizadas ?? 0}
                                                                                        onChange={(e) => laborRestringida(lab) ? null : ajustar_cumplimiento(i, j, e.target.value)}
                                                                                    />
                                                                                    <button className='btn btn-sm btn-light shadow-sm border border-warning p-0 text-center mt-1'
                                                                                        onClick={() => {
                                                                                            ajustar_cumplimiento(i, j, lab.asignado)
                                                                                        }}
                                                                                        style={{ 'width': '40%' }}>
                                                                                        Realizar
                                                                                    </button>
                                                                                    <div className="w m-0 p-0 mb-1" style={{ '--w': '100%' }}></div>
                                                                                    {barraAvance(i, j)}
                                                                                </div>}
                                                                                {(lab.otp_id === null || !fechaAjustada() || laborRestringida(lab)) && `${(lab.unidades_realizadas ?? 0)} - ${lab.labor.um}`}
                                                                            </td>
                                                                            <td className='text-end pe-3 nowrap align-middle' style={{ width: "180px" }}>{+(lab.labor.ms_by_unidad * lab.asignado / 3600000).toFixed(2)} Horas</td>
                                                                            <td className='border-start text-center nowrap align-middle' style={{ width: "150px" }}>
                                                                                <button className={`btn btn-sm btn-${lab.otp_id === null || laborRestringida(lab) ? 'secondary' : 'danger'} border-2 border round-xs p-0 bw-100`}
                                                                                    disabled={(lab.unidades_realizadas ?? 0) > 0 || lab.otp_id === null || laborRestringida(lab)}
                                                                                    onClick={() => laborRestringida(lab) ? () => { } : deleteOrdenBackend(lab.otp_id, i, j)}>
                                                                                    {lab.otp_id === null || laborRestringida(lab) ? 'No aplica' : 'Eliminar'}
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                                <tr className='border-none'>
                                                                    <td className='nowrap border-none'>{dibujarBarrasAvanceNomina(e.labores, e.contratista)}</td>
                                                                    <td className='nowrap text-s text-start border-none'>
                                                                        Unidades asignadas:<span className='text-bold text-m text-blue3 ms-1'>{
                                                                            +(e.labores.reduce((total, lab) => total + lab.asignado, 0)).toFixed(2)
                                                                        }<span className='text-s text-300'> Unidades</span>
                                                                        </span>
                                                                    </td>
                                                                    <td className='text-start nowrap text-s border-none'>
                                                                        Total Realizado:<span className='text-bold h5 text-green4 ms-1'>{
                                                                            +(e.labores.reduce((total, lab) => total + (lab.labor.ms_by_unidad * lab.unidades_realizadas), 0) / 3600000).toFixed(2)
                                                                        }<span className='text-s'> Horas</span>
                                                                        </span>
                                                                    </td>
                                                                    <td className='nowrap text-s border-none text-end'>
                                                                        Total asingado:<span className='text-bold h5 text-green4 ms-1'>{
                                                                            +(e.labores.reduce((total, lab) => total + (lab.labor.ms_by_unidad * lab.asignado), 0) / 3600000).toFixed(2)
                                                                        }<span className='text-s'> Horas</span>
                                                                        </span>
                                                                    </td>
                                                                    <td className='text-start ps-2 nowrap h5 border-none' > </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>}
                </div>
            </div >
            {loader ? ldr : null}
            < VainillaDialog data={dialog} />
            {abrirImpresiones && <ImpresoraDeOrdenesTrabajoasignadas ordenes={ordenes} empleados={empleados} close={() => setabrirImpresiones(false)} loader={setloader} />}
        </>

    )
}

export default OrdenesTrabajoInferidas;